import React, { useState } from 'react';
import styles from '../PROJECTS/projects.module.css';


const Projects = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleVideoClick = () => {
    setShowVideo(!showVideo);
  };

  return (

    <div className={styles.projectsContainer}>
      <div className={styles.project}>
        <a href='https://somosedison.com' target='blank'>
          <img src={process.env.PUBLIC_URL + '/Edison.jpg'} alt="Project Edison" />
          <h3>Somos Edison</h3>
          <p>Implementacion de un flujo de pago automático para reducir la carga operativa y mejorar la experiencia del usuario en Somos Edison. Durante este proyecto, creamos una réplica del sitio web e integramos métodos de pago de Mercado Libre y Stripe. Además de un marketplace, una sección de preguntas, la capacidad de crear y ver cursos.</p>
          
          <p className={styles.tecnologias}>HTML5, JavaScript, Airtable, Bootstrap, React, Redux, Express, AWS, sNode.js y GitHub.</p>
        </a>

      </div>
      <div className={styles.project} onClick={handleVideoClick}>
        <img src={process.env.PUBLIC_URL + '/Pokemon.jpg'} alt="Project Pokemon" />
        <h3>Pokemon</h3>
        <p>
        Aplicación web basada en la temática de Pokémon. Esta aplicación permite a los usuarios crear, buscar y filtrar información detallada sobre distintos pokémones obtenidos de una API. Ademas de un About con informacion sobre mi y un paginado de acuerdo al filtrado, ya se por tipo, alfabeto, etc.
        </p>
        
        <p className={styles.tecnologias}>
        JavaScript, Node.js, Express, React, Redux, PostgreSQL, GitHub, CSS y HTML5.
        </p>
      </div>
      {showVideo && (
        <div className={styles.videoContainer}>
          <iframe
            title="Project Pokemon"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/-Lx2u13GXBA"
            frameborder="0"
            allowfullscreen
            allow="fullscreen"
          ></iframe>
        </div>
      )}
    </div>


  );
};

export default Projects;
